import { ContentPanel } from 'features/content-library/components/ContentPanel/ContentPanel';
import { selectPreviewedFile } from 'features/content-library/contentLibrarySlice';
import { WhiteboardPanel } from 'features/whiteboard/WhiteboardPanel';
import { useAppSelector } from 'store/hooks';

type PreviewPanelProps = {
  size: { width?: number; height?: number };
};

export const PreviewPanel = ({ size }: PreviewPanelProps) => {
  const previewedFile = useAppSelector(selectPreviewedFile);

  if (!previewedFile) {
    return null;
  }

  if (previewedFile.type === 'whiteboard') {
    return <WhiteboardPanel isPreview />;
  }

  return <ContentPanel isPreview size={size} />;
};
